<template>
  <div>
    <el-row :gutter="10" class="sales-time"
      v-for="(sales, idx) in timeSales"
      :key="idx"
      >
      <el-col :xs="16" :md="4" class="sales-time-button">
        <el-form-item
          :label="idx > 0 ? '' : $t('api.sales.availableTime')"
          >
          <el-button type="primary" icon="el-icon-plus" circle
            @click="addSales(idx)"
            ></el-button>
          <el-button type="danger" icon="el-icon-minus" circle
            v-if="timeSales.length > 1"
            @click="minusSales(idx)"
            ></el-button>
        </el-form-item>
      </el-col>
      <el-col :xs="16" :md="6">
        <el-form-item
          :label="idx > 0 ? '' : $t('api.sales.fields.start.label')"
          >
          <el-time-select
            v-model="sales.start_time"
            :picker-options="sales.startOpt"
            @change="changeStart(idx, sales.start_time)"
            :placeholder="$t('api.sales.time.placeholder')">
          </el-time-select>
        </el-form-item>
      </el-col>
      <el-col :xs="16" :md="6">
        <el-form-item
          :label="idx > 0 ? '' : $t('api.sales.fields.end.label')"
          >
          <el-time-select
            v-model="sales.end_time"
            :picker-options="sales.endOpt"
            @change="changeEnd(idx, sales.end_time)"
            :placeholder="$t('api.sales.time.placeholder')">
          </el-time-select>
          <div class="el-form-item__error next-day-text">
            {{ sales.nextDayText }}
          </div>
        </el-form-item>
      </el-col>
      <el-col :xs="16" :md="4">
        <el-form-item
          :label="idx > 0 ? '' : $t('api.sales.fields.price.label')"
          >
          <el-input
            v-model.number="sales.price"
            ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="16" :md="4">
        <el-form-item
          :label="idx > 0 ? '' : $t('api.sales.fields.sell_limit.label')"
          >
          <el-input
            v-model.number="sales.sell_limit"
            ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>

const defStartOpt = {
  start: '00:00',
  step: '00:15',
  end: '23:45'
}

const defEndOpt = {
  start: '00:15',
  step: '00:15',
  end: '47:45'
}

const defSales = {
  start_time: '',
  end_time: '',
  price: null,
  sell_limit: null,
  nextDayText: '',
  startOpt: Object.assign({}, defStartOpt),
  endOpt: Object.assign({}, defEndOpt)
}

export default {
  name: 'sales-time',
  props: {
    value: null,
    product: null
  },
  data () {
    return {
      timeSales: [
        Object.assign({}, defSales)
      ]
    }
  },
  created () {
  },
  mounted () {
    this.$emit('updateSales', this.timeSales)
  },
  watch: {
    value (v) {
      this.timeSales.splice(0, this.timeSales.length)
      v.forEach((item, idx, array) => {
        var s = Object.assign({}, defStartOpt)
        var e = Object.assign({}, defEndOpt)
        e.minTime = item.start_time
        e.start = item.start_time
        item.startOpt = s
        item.endOpt = e
        this.timeSales.push(item)
      })
    },
    timeSales () {
      this.$emit('updateSales', this.timeSales)
    },
    product (p) {
      this.timeSales.forEach((item, idx, array) => {
        if (item.price === null) {
          item.price = p.price
        }
        if (item.sell_limit === null) {
          item.sell_limit = p.sell_limit
        }
      })
    }
  },
  methods: {
    nextStep (v, diff) {
      var arr = v.split(':')
      var hour = parseInt(arr[0], 10) || 0
      var min = parseInt(arr[1], 10) || 0
      min += diff * 15
      if (min >= 60) {
        min -= 60
        hour += 1
      }
      hour = (hour >= 10) ? hour : '0' + hour
      min = (min >= 10) ? min : '0' + min
      return hour + ':' + min
    },
    addSales (idx) {
      var sales = Object.assign({}, this.timeSales[idx])
      if (sales.end_time !== '') {
        sales.start_time = sales.end_time
        if (sales.start_time >= '23:45') {
          return
        }
        sales.end_time = this.nextStep(sales.end_time, 1)
        this.setNextDayText(sales.end_time, idx)
        var sopt = sales.startOpt
        sopt.start = this.nextStep(sales.start_time, -1)
        sopt.minTime = sopt.start
        // copy a new object to force re-new component
        sales.startOpt = Object.assign({}, sopt)
        var opt = sales.endOpt
        opt.start = sales.end_time
        opt.minTime = sales.end_time
        sales.endOpt = Object.assign({}, opt)
      }
      this.timeSales.splice(idx + 1, 0, sales)
    },
    minusSales (idx) {
      this.timeSales.splice(idx, 1)
    },
    changeStart (idx, v) {
      var sales = this.timeSales[idx]
      var opt = sales.endOpt
      if (v >= sales.end_time) {
        sales.end_time = this.nextStep(v, 1)
        this.setNextDayText(sales.end_time, idx)
      }
      opt.start = v
      opt.minTime = v
      // copy a new object to force re-new component
      sales.endOpt = Object.assign({}, opt)
    },
    changeEnd (idx, v) {
      this.setNextDayText(v, idx)
    },
    setNextDayText (v, idx) {
      if (v === null) {
        return
      }
      var arr = v.split(':')
      var hour = parseInt(arr[0], 10) || 0
      if (hour < 24) {
        this.timeSales[idx].nextDayText = ''
        return
      }
      hour -= 24
      hour = (hour >= 10) ? hour : '0' + hour
      this.timeSales[idx].nextDayText = hour + ':' + arr[1] + this.$t('api.sales.nextDay')
    }
  }
}
</script>
